import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import * as authActions from './authActions'; 

import TinyJellyShape from './../../containers/UI/Common/JellyShape/TinyJellyShape';
import DoubleHalfCircle from './../../containers/UI/Common/Shapes/DoubleHalfCircle';
import Zigzag from './../../containers/UI/Common/Shapes/Zigzag';
import Image from './../../containers/UI/Image/Image';
import MessageModal from './../../containers/UI/MessageModal/MessageModal';

import LoginForm from './../forms/loginForm';

//-- Utils
import { pushPageView } from '../../utils/tracking/customGtm';
import { pushHeaderTitle } from '../../utils/dom/helper';

// Assets
import MonstreImg from '../../assets/images/kiddy.svg';
import LogoImg from '../../assets/images/logo/logo_kidsmatin_desk.svg';


export class Auth extends Component {

    componentDidMount() {
        //-- Update title
        pushHeaderTitle('Connexion');

        //-- Push GTM page view
        pushPageView();
    }

    onClick = () => {
        const { dispatch } = this.props;
        dispatch(authActions.logout());
    }

    onClickContactHandler = () => {
        const { dispatch } = this.props;
        dispatch(push('/contact'));
    }

    closeModalHandler = () => {
        const { dispatch } = this.props;
        dispatch(authActions.removeError());
    }

    closePageHandler = () => {
        const { dispatch } = this.props;
        dispatch(push('/'));
    }

    CreateProfileHandler = () => {
        const { dispatch } = this.props;
        dispatch(push('/account/create'));
    }

    render(){
        const { hasError, errorMessage } = this.props;

        return(
            <div className="login-page-container">
                <div className="close-page" onClick={this.closePageHandler}></div>
                <MessageModal 
                    show={hasError}
                    closeModalHandler={this.closeModalHandler}
                    image="error"
                    message= {errorMessage}
                    zigzagColor="#49d1e5"
                    zigzagClass="blue-shape"
                />
                <div id="mainLogo">
                    <Image
                        isResponsive='true'
                        imgPath={LogoImg}
                        imgName="logo-kids"
                    />
                </div>
                <div className="login-container">
                    <TinyJellyShape color="#3c277f" translate="70px"/>
                    <div id="mainCharacter">
                        <Image
                            imgPath={MonstreImg}
                            imgName="intro-monstre"
                        />
                    </div>
                    <div className="yellow-shape">
                        <Zigzag color="#ffde39" translateXaxis="20" />
                    </div>
                    <LoginForm class="login-form" name="loginForm"/>
                    <div className="create_profile" onClick={this.CreateProfileHandler}>
                        1ère connexion? Je crée mon profil
                    </div>
                    <div className="contactBtn" onClick={this.onClickContactHandler}>contact</div>
                </div>
                <div className="dual-half-circle">
                    <DoubleHalfCircle color1='#fff' color2='#fcea10' rotateAngle="5"/>
                </div>  
                
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isUserSignedIn: state.auth.isUserSignedIn,
        hasError: state.auth.hasError,
        errorMessage: state.auth.errorMessage
    }
};


export default connect( mapStateToProps )(Auth);





// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js